function init() {
  // utilities
  import('utility/page-restore').then((module) => module.default.init())
  import('utility/prefetch').then((module) => module.default.init())
  import('utility/smooth-scroll').then((module) => module.default.init())
  import('utility/vertical-resize-check').then((module) => module.default.init())

  if (document.querySelector('.richtext')) {
    import('utility/richtextApi').then((module) => module.default.init())
  }

  // blocks

  if (document.querySelector<HTMLElement>('.calculator-95-block')) {
    import('blocks/calculator-95-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.calculator-block')) {
    import('blocks/calculator-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.chart-block') || document.querySelector<HTMLElement>('.embeds-block')) {
    import('blocks/chart-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.comparison-table-block')) {
    import('blocks/comparison-table-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.faq-block')) {
    import('blocks/faq-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.grading-block')) {
    import('blocks/grading-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.icon-cards-block')) {
    import('blocks/icon-cards-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.slider-block')) {
    import('blocks/slider-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.table-block')) {
    import('blocks/table-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.table-category-block')) {
    import('blocks/table-category-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.life-steps-block')) {
    import('blocks/life-steps-block').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.rating-block')) {
    import('./blocks/ar-rating-block').then((module) => module.default.init())
  }

  // components

  if (document.querySelector<HTMLElement>('.accordion')) {
    import('components/accordion').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.alert')) {
    import('components/alerts').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.back-to-top')) {
    import('components/back-to-top').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.header') || document.querySelector<HTMLElement>('.header-ar')) {
    import('components/navigation').then((navigationModule) => {
      navigationModule.default.init()
      import('components/loader').then((loaderModule) => {
        loaderModule.default.init()
      })
    })
  }

  if (document.querySelector<HTMLElement>('.chapter-progress-bar')) {
    import('components/chapter-progress-bar').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.ar-search-popup')) {
    import('components/search-popup-ar').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-file')) {
    import('components/input-file').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-group')) {
    import('components/input-group').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.input-range')) {
    import('components/input-range').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.picture')) {
    import('components/picture').then((module) => module.default.init())
  }

  if (document.querySelector('.form')) {
    import('./components/form').then((module) => module.default.init())
  }

  // pages

  if (document.querySelector<HTMLElement>('.articles-page')) {
    import('pages/articles-page').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.contact-page')) {
    import('pages/contact-page').then((module) => module.default.init())
  }

  if (document.querySelector<HTMLElement>('.forms-page')) {
    import('pages/forms-page').then((module) => module.default.init())
  }
  if (document.querySelector<HTMLElement>('.search-page')) {
    import('pages/search-page').then((module) => module.default.init())
  }

  // dev helpers

  if (process.env.NODE_ENV !== 'production') {
    import('utility/keyboard-shortcuts').then((module) => {
      module.contentEditable.init()
      module.goToPage.init(['shift', 'b'], '/blocks')
      module.goToPage.init(['shift', 's'], '/styleguide')
    })
    import('utility/overlay-grid').then((module) => module.default.init())
  }

  // page load

  document.body.classList.remove('noscript')

  setTimeout(() => {
    // if (sessionStorage.getItem('pageLoaded') === 'true') {
    document.body.classList.remove('preload')
    // }
  }, 123)
}

function initArSearch() {
  if (document.querySelector<HTMLElement>('.ar-search-popup')) {
    import('components/search-popup-ar').then((module) => module.default.init())
  }
}

document.addEventListener('DOMContentLoaded', init)

// handle javascript related to htmx events
document.body.addEventListener('htmx:afterSettle', initArSearch)
